import { validate } from '../../../utils/validate';

const validationPropsByField = {
  addressLine2: { required: false, type: 'additionalAddressField' },
  addressLine3: { required: false, type: 'additionalAddressField' },
  apartment: { required: false, type: 'apartment' },
  city: { required: true, type: 'city' },
  company: { required: false, type: 'company' },
  confirmEmail: {
    comparisonInput: 'newEmail',
    name: 'Email addresses',
    required: true,
    type: 'confirmInput',
  },
  confirmMobileNumber: {
    comparisonInput: 'newMobileNumber',
    name: 'Mobile numbers',
    required: true,
    type: 'confirmInput',
  },
  confirmNewPassword: {
    comparisonInput: 'newPassword',
    name: 'Passwords',
    required: true,
    type: 'confirmInput',
  },
  country: { required: true, type: 'textInput' },
  lastFourSsn: { required: true, type: 'ssnTin' },
  loanNumber: { required: true, type: 'loanNumber' },
  newEmail: { required: true, type: 'email' },
  newMobileNumber: { required: true, type: 'phone' },
  newPassword: { required: true, type: 'password' },
  oldPassword: { required: true, type: 'oldPassword' },
  passCode: { required: true, type: 'passCode' },
  phoneNumber: { required: true, type: 'phone' },
  postalCode: { required: false, type: 'postalCode' },
  propertyZip: { required: true, type: 'zipCode' },
  province: { required: true, type: 'textInput' },
  state: { required: true, type: 'textInput' },
  streetAddress: { required: true, type: 'streetAddress' },
  zip: { required: true, type: 'zipCode' },
};

export const validateFields = ({ formErrors, values }) =>
  Object.keys(values).reduce((acc, field) => {
    const error = validateOneField({ field, values });
    acc.validationErrors[field] = error || '';
    if (error) {
      acc.isValidated = false;
    }
    return acc;
  }, { isValidated: true, validationErrors: { ...formErrors } });

export const validateOneField = ({ field, values }) => {
  const value = values[field];
  const validationProps = validationPropsByField[field];
  if (validationProps) {
    const { comparisonInput } = validationProps;
    return validate({
      comparisonValue: values[comparisonInput],
      value,
      ...validationProps,
    });
  }
  return false;
};
